import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./MobileSteps.css"; // <-- Import the CSS file

gsap.registerPlugin(ScrollTrigger);

export default function MobileSteps({ steps }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const stepsEls = gsap.utils.toArray(".mobile-step");

      stepsEls.forEach((step) => {
        const line = step.querySelector(".line-fill");
        const text = step.querySelector(".text-content-mobile");
        const img = step.querySelector("step-img");

        // Animate line fill
        gsap.fromTo(
          line,
          { height: 0 },
          {
            height: "9rem",
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: step,
              start: "top 70%",
              toggleActions: "play none none reverse",
            },
          }
        );

        // Animate text
        gsap.fromTo(
          text,
          { autoAlpha: 0, y: 30 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            delay: 0.2,
            scrollTrigger: {
              trigger: step,
              start: "top 65%",
              toggleActions: "play none none reverse",
            },
          }
        );

        // Animate image
        gsap.fromTo(
          img,
          { autoAlpha: 0, y: 40 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            delay: 0.4,
            scrollTrigger: {
              trigger: step,
              start: "top 60%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={containerRef} className="mobile-steps-container">
      {steps.map((s, i) => (
        <div key={i} className="mobile-step">
          {/* Step label */}
          <p className="step-label">{s.step}</p>

          {/* Line */}
          <div className="line-bg">
            <div className="line-fill"></div>
          </div>

          {/* Text */}
          <div className="text-content-mobile">
            <h2 className="step-title">{s.title}</h2>
            <p className="step-desc">{s.desc}</p>
          </div>

          {/* Image */}
          <img src={s.mobileImg} alt="" className="step-img" />
        </div>
      ))}
    </div>
  );
}
